"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.SuperadminApi = exports.SuperadminApiFactory = exports.SuperadminApiFp = exports.SuperadminApiAxiosParamCreator = exports.MemberSSOApi = exports.MemberSSOApiFactory = exports.MemberSSOApiFp = exports.MemberSSOApiAxiosParamCreator = exports.DevApi = exports.DevApiFactory = exports.DevApiFp = exports.DevApiAxiosParamCreator = exports.CallCentreApi = exports.CallCentreApiFactory = exports.CallCentreApiFp = exports.CallCentreApiAxiosParamCreator = exports.AuthenticationApi = exports.AuthenticationApiFactory = exports.AuthenticationApiFp = exports.AuthenticationApiAxiosParamCreator = exports.Auth0Api = exports.Auth0ApiFactory = exports.Auth0ApiFp = exports.Auth0ApiAxiosParamCreator = exports.CommunicationLanguage = exports.AgeCategory = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.AgeCategory = {
    Adult: 'adult',
    Minor: 'minor',
    Unknown: 'unknown'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CommunicationLanguage = {
    English: 'english',
    French: 'french',
    German: 'german'
};
/**
 * Auth0Api - axios parameter creator
 * @export
 */
var Auth0ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Run login actions for the Auth0 user and return the updated Auth0 user.  This endpoint expects to be called in the context of an Auth0 login action.  The `multipass:login:user` scope is required to access this endpoint.
         * @summary Run login actions for the Auth0 user.
         * @param {LoginRequest} loginRequest
         * @param {string} [userAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuth0LoginPost: function (loginRequest_1, userAgent_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([loginRequest_1, userAgent_1], args_1, true), void 0, function (loginRequest, userAgent, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loginRequest' is not null or undefined
                            (0, common_1.assertParamExists)('loginAuth0LoginPost', 'loginRequest', loginRequest);
                            localVarPath = "/auth0/login";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            if (userAgent != null) {
                                localVarHeaderParameter['user-agent'] = String(userAgent);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loginRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create machine claims
         * @param {CreateMachineClaimsEvent} createMachineClaimsEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineClaimsAuth0MachineClaimsPost: function (createMachineClaimsEvent_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createMachineClaimsEvent_1], args_1, true), void 0, function (createMachineClaimsEvent, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createMachineClaimsEvent' is not null or undefined
                            (0, common_1.assertParamExists)('machineClaimsAuth0MachineClaimsPost', 'createMachineClaimsEvent', createMachineClaimsEvent);
                            localVarPath = "/auth0/machine-claims";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createMachineClaimsEvent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.Auth0ApiAxiosParamCreator = Auth0ApiAxiosParamCreator;
/**
 * Auth0Api - functional programming interface
 * @export
 */
var Auth0ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.Auth0ApiAxiosParamCreator)(configuration);
    return {
        /**
         * Run login actions for the Auth0 user and return the updated Auth0 user.  This endpoint expects to be called in the context of an Auth0 login action.  The `multipass:login:user` scope is required to access this endpoint.
         * @summary Run login actions for the Auth0 user.
         * @param {LoginRequest} loginRequest
         * @param {string} [userAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuth0LoginPost: function (loginRequest, userAgent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginAuth0LoginPost(loginRequest, userAgent, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['Auth0Api.loginAuth0LoginPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create machine claims
         * @param {CreateMachineClaimsEvent} createMachineClaimsEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineClaimsAuth0MachineClaimsPost: function (createMachineClaimsEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.machineClaimsAuth0MachineClaimsPost(createMachineClaimsEvent, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['Auth0Api.machineClaimsAuth0MachineClaimsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.Auth0ApiFp = Auth0ApiFp;
/**
 * Auth0Api - factory interface
 * @export
 */
var Auth0ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.Auth0ApiFp)(configuration);
    return {
        /**
         * Run login actions for the Auth0 user and return the updated Auth0 user.  This endpoint expects to be called in the context of an Auth0 login action.  The `multipass:login:user` scope is required to access this endpoint.
         * @summary Run login actions for the Auth0 user.
         * @param {LoginRequest} loginRequest
         * @param {string} [userAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAuth0LoginPost: function (loginRequest, userAgent, options) {
            return localVarFp.loginAuth0LoginPost(loginRequest, userAgent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create machine claims
         * @param {CreateMachineClaimsEvent} createMachineClaimsEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineClaimsAuth0MachineClaimsPost: function (createMachineClaimsEvent, options) {
            return localVarFp.machineClaimsAuth0MachineClaimsPost(createMachineClaimsEvent, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.Auth0ApiFactory = Auth0ApiFactory;
/**
 * Auth0Api - object-oriented interface
 * @export
 * @class Auth0Api
 * @extends {BaseAPI}
 */
var Auth0Api = /** @class */ (function (_super) {
    __extends(Auth0Api, _super);
    function Auth0Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Run login actions for the Auth0 user and return the updated Auth0 user.  This endpoint expects to be called in the context of an Auth0 login action.  The `multipass:login:user` scope is required to access this endpoint.
     * @summary Run login actions for the Auth0 user.
     * @param {LoginRequest} loginRequest
     * @param {string} [userAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Auth0Api
     */
    Auth0Api.prototype.loginAuth0LoginPost = function (loginRequest, userAgent, options) {
        var _this = this;
        return (0, exports.Auth0ApiFp)(this.configuration).loginAuth0LoginPost(loginRequest, userAgent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create machine claims
     * @param {CreateMachineClaimsEvent} createMachineClaimsEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Auth0Api
     */
    Auth0Api.prototype.machineClaimsAuth0MachineClaimsPost = function (createMachineClaimsEvent, options) {
        var _this = this;
        return (0, exports.Auth0ApiFp)(this.configuration).machineClaimsAuth0MachineClaimsPost(createMachineClaimsEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return Auth0Api;
}(base_1.BaseAPI));
exports.Auth0Api = Auth0Api;
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
var AuthenticationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get the challenges associated with a member\'s profile.
         * @summary Get User Challenges
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChallengesAuthenticateAuthIdChallengeGet: function (authId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([authId_1], args_1, true), void 0, function (authId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'authId' is not null or undefined
                            (0, common_1.assertParamExists)('userChallengesAuthenticateAuthIdChallengeGet', 'authId', authId);
                            localVarPath = "/authenticate/{auth_id}/challenge"
                                .replace("{".concat("auth_id", "}"), encodeURIComponent(String(authId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Check if a member\'s pin is valid.
         * @summary Check if a member\'s pin is valid.
         * @param {BodyAuthenticateUserPinAuthenticatePinPost} bodyAuthenticateUserPinAuthenticatePinPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPinAuthenticatePinPost: function (bodyAuthenticateUserPinAuthenticatePinPost_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bodyAuthenticateUserPinAuthenticatePinPost_1], args_1, true), void 0, function (bodyAuthenticateUserPinAuthenticatePinPost, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bodyAuthenticateUserPinAuthenticatePinPost' is not null or undefined
                            (0, common_1.assertParamExists)('userPinAuthenticatePinPost', 'bodyAuthenticateUserPinAuthenticatePinPost', bodyAuthenticateUserPinAuthenticatePinPost);
                            localVarPath = "/authenticate/pin";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bodyAuthenticateUserPinAuthenticatePinPost, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AuthenticationApiAxiosParamCreator = AuthenticationApiAxiosParamCreator;
/**
 * AuthenticationApi - functional programming interface
 * @export
 */
var AuthenticationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AuthenticationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get the challenges associated with a member\'s profile.
         * @summary Get User Challenges
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChallengesAuthenticateAuthIdChallengeGet: function (authId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userChallengesAuthenticateAuthIdChallengeGet(authId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthenticationApi.userChallengesAuthenticateAuthIdChallengeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Check if a member\'s pin is valid.
         * @summary Check if a member\'s pin is valid.
         * @param {BodyAuthenticateUserPinAuthenticatePinPost} bodyAuthenticateUserPinAuthenticatePinPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPinAuthenticatePinPost: function (bodyAuthenticateUserPinAuthenticatePinPost, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userPinAuthenticatePinPost(bodyAuthenticateUserPinAuthenticatePinPost, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthenticationApi.userPinAuthenticatePinPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AuthenticationApiFp = AuthenticationApiFp;
/**
 * AuthenticationApi - factory interface
 * @export
 */
var AuthenticationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AuthenticationApiFp)(configuration);
    return {
        /**
         * Get the challenges associated with a member\'s profile.
         * @summary Get User Challenges
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChallengesAuthenticateAuthIdChallengeGet: function (authId, options) {
            return localVarFp.userChallengesAuthenticateAuthIdChallengeGet(authId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check if a member\'s pin is valid.
         * @summary Check if a member\'s pin is valid.
         * @param {BodyAuthenticateUserPinAuthenticatePinPost} bodyAuthenticateUserPinAuthenticatePinPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPinAuthenticatePinPost: function (bodyAuthenticateUserPinAuthenticatePinPost, options) {
            return localVarFp.userPinAuthenticatePinPost(bodyAuthenticateUserPinAuthenticatePinPost, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AuthenticationApiFactory = AuthenticationApiFactory;
/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
var AuthenticationApi = /** @class */ (function (_super) {
    __extends(AuthenticationApi, _super);
    function AuthenticationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get the challenges associated with a member\'s profile.
     * @summary Get User Challenges
     * @param {string} authId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    AuthenticationApi.prototype.userChallengesAuthenticateAuthIdChallengeGet = function (authId, options) {
        var _this = this;
        return (0, exports.AuthenticationApiFp)(this.configuration).userChallengesAuthenticateAuthIdChallengeGet(authId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check if a member\'s pin is valid.
     * @summary Check if a member\'s pin is valid.
     * @param {BodyAuthenticateUserPinAuthenticatePinPost} bodyAuthenticateUserPinAuthenticatePinPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    AuthenticationApi.prototype.userPinAuthenticatePinPost = function (bodyAuthenticateUserPinAuthenticatePinPost, options) {
        var _this = this;
        return (0, exports.AuthenticationApiFp)(this.configuration).userPinAuthenticatePinPost(bodyAuthenticateUserPinAuthenticatePinPost, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthenticationApi;
}(base_1.BaseAPI));
exports.AuthenticationApi = AuthenticationApi;
/**
 * CallCentreApi - axios parameter creator
 * @export
 */
var CallCentreApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Update your own user PIN.
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfPinUsersMePinPut: function (body_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([body_1], args_1, true), void 0, function (body, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'body' is not null or undefined
                            (0, common_1.assertParamExists)('selfPinUsersMePinPut', 'body', body);
                            localVarPath = "/users/me/pin";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the challenges associated with a member\'s profile.
         * @summary Get User Challenges
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChallengesAuthenticateAuthIdChallengeGet: function (authId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([authId_1], args_1, true), void 0, function (authId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'authId' is not null or undefined
                            (0, common_1.assertParamExists)('userChallengesAuthenticateAuthIdChallengeGet', 'authId', authId);
                            localVarPath = "/authenticate/{auth_id}/challenge"
                                .replace("{".concat("auth_id", "}"), encodeURIComponent(String(authId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Check if a member\'s pin is valid.
         * @summary Check if a member\'s pin is valid.
         * @param {BodyAuthenticateUserPinAuthenticatePinPost} bodyAuthenticateUserPinAuthenticatePinPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPinAuthenticatePinPost: function (bodyAuthenticateUserPinAuthenticatePinPost_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bodyAuthenticateUserPinAuthenticatePinPost_1], args_1, true), void 0, function (bodyAuthenticateUserPinAuthenticatePinPost, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bodyAuthenticateUserPinAuthenticatePinPost' is not null or undefined
                            (0, common_1.assertParamExists)('userPinAuthenticatePinPost', 'bodyAuthenticateUserPinAuthenticatePinPost', bodyAuthenticateUserPinAuthenticatePinPost);
                            localVarPath = "/authenticate/pin";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bodyAuthenticateUserPinAuthenticatePinPost, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the pin of a member.
         * @param {string} authId
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPinUsersAuthIdPinPut: function (authId_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([authId_1, body_1], args_1, true), void 0, function (authId, body, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'authId' is not null or undefined
                            (0, common_1.assertParamExists)('userPinUsersAuthIdPinPut', 'authId', authId);
                            // verify required parameter 'body' is not null or undefined
                            (0, common_1.assertParamExists)('userPinUsersAuthIdPinPut', 'body', body);
                            localVarPath = "/users/{auth_id}/pin"
                                .replace("{".concat("auth_id", "}"), encodeURIComponent(String(authId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a user on Auth0.  Create an Auth0 user with the given email address, claims its eligibility if available and run login actions if specified.  If the user has active eligibility and login actions were run, the user should be fully provisioned in the platform. Users are auto-verified upon creation.  If the Auth0 user already exists, it will be used to complete the remaining actions. In that case, if we don\'t find a unique match for the email, a 409 Conflict response will be returned.  The `multipass:create:user` scope is required to access this endpoint.
         * @summary Create User
         * @param {CreateUserRequest} createUserRequest
         * @param {string} [userAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUsersPut: function (createUserRequest_1, userAgent_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createUserRequest_1, userAgent_1], args_1, true), void 0, function (createUserRequest, userAgent, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createUserRequest' is not null or undefined
                            (0, common_1.assertParamExists)('userUsersPut', 'createUserRequest', createUserRequest);
                            localVarPath = "/users";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            if (userAgent != null) {
                                localVarHeaderParameter['user-agent'] = String(userAgent);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createUserRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CallCentreApiAxiosParamCreator = CallCentreApiAxiosParamCreator;
/**
 * CallCentreApi - functional programming interface
 * @export
 */
var CallCentreApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CallCentreApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Update your own user PIN.
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfPinUsersMePinPut: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.selfPinUsersMePinPut(body, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CallCentreApi.selfPinUsersMePinPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get the challenges associated with a member\'s profile.
         * @summary Get User Challenges
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChallengesAuthenticateAuthIdChallengeGet: function (authId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userChallengesAuthenticateAuthIdChallengeGet(authId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CallCentreApi.userChallengesAuthenticateAuthIdChallengeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Check if a member\'s pin is valid.
         * @summary Check if a member\'s pin is valid.
         * @param {BodyAuthenticateUserPinAuthenticatePinPost} bodyAuthenticateUserPinAuthenticatePinPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPinAuthenticatePinPost: function (bodyAuthenticateUserPinAuthenticatePinPost, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userPinAuthenticatePinPost(bodyAuthenticateUserPinAuthenticatePinPost, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CallCentreApi.userPinAuthenticatePinPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the pin of a member.
         * @param {string} authId
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPinUsersAuthIdPinPut: function (authId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userPinUsersAuthIdPinPut(authId, body, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CallCentreApi.userPinUsersAuthIdPinPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a user on Auth0.  Create an Auth0 user with the given email address, claims its eligibility if available and run login actions if specified.  If the user has active eligibility and login actions were run, the user should be fully provisioned in the platform. Users are auto-verified upon creation.  If the Auth0 user already exists, it will be used to complete the remaining actions. In that case, if we don\'t find a unique match for the email, a 409 Conflict response will be returned.  The `multipass:create:user` scope is required to access this endpoint.
         * @summary Create User
         * @param {CreateUserRequest} createUserRequest
         * @param {string} [userAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUsersPut: function (createUserRequest, userAgent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userUsersPut(createUserRequest, userAgent, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CallCentreApi.userUsersPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CallCentreApiFp = CallCentreApiFp;
/**
 * CallCentreApi - factory interface
 * @export
 */
var CallCentreApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CallCentreApiFp)(configuration);
    return {
        /**
         *
         * @summary Update your own user PIN.
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfPinUsersMePinPut: function (body, options) {
            return localVarFp.selfPinUsersMePinPut(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the challenges associated with a member\'s profile.
         * @summary Get User Challenges
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userChallengesAuthenticateAuthIdChallengeGet: function (authId, options) {
            return localVarFp.userChallengesAuthenticateAuthIdChallengeGet(authId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check if a member\'s pin is valid.
         * @summary Check if a member\'s pin is valid.
         * @param {BodyAuthenticateUserPinAuthenticatePinPost} bodyAuthenticateUserPinAuthenticatePinPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPinAuthenticatePinPost: function (bodyAuthenticateUserPinAuthenticatePinPost, options) {
            return localVarFp.userPinAuthenticatePinPost(bodyAuthenticateUserPinAuthenticatePinPost, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update the pin of a member.
         * @param {string} authId
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPinUsersAuthIdPinPut: function (authId, body, options) {
            return localVarFp.userPinUsersAuthIdPinPut(authId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a user on Auth0.  Create an Auth0 user with the given email address, claims its eligibility if available and run login actions if specified.  If the user has active eligibility and login actions were run, the user should be fully provisioned in the platform. Users are auto-verified upon creation.  If the Auth0 user already exists, it will be used to complete the remaining actions. In that case, if we don\'t find a unique match for the email, a 409 Conflict response will be returned.  The `multipass:create:user` scope is required to access this endpoint.
         * @summary Create User
         * @param {CreateUserRequest} createUserRequest
         * @param {string} [userAgent]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUsersPut: function (createUserRequest, userAgent, options) {
            return localVarFp.userUsersPut(createUserRequest, userAgent, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CallCentreApiFactory = CallCentreApiFactory;
/**
 * CallCentreApi - object-oriented interface
 * @export
 * @class CallCentreApi
 * @extends {BaseAPI}
 */
var CallCentreApi = /** @class */ (function (_super) {
    __extends(CallCentreApi, _super);
    function CallCentreApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Update your own user PIN.
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCentreApi
     */
    CallCentreApi.prototype.selfPinUsersMePinPut = function (body, options) {
        var _this = this;
        return (0, exports.CallCentreApiFp)(this.configuration).selfPinUsersMePinPut(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the challenges associated with a member\'s profile.
     * @summary Get User Challenges
     * @param {string} authId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCentreApi
     */
    CallCentreApi.prototype.userChallengesAuthenticateAuthIdChallengeGet = function (authId, options) {
        var _this = this;
        return (0, exports.CallCentreApiFp)(this.configuration).userChallengesAuthenticateAuthIdChallengeGet(authId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check if a member\'s pin is valid.
     * @summary Check if a member\'s pin is valid.
     * @param {BodyAuthenticateUserPinAuthenticatePinPost} bodyAuthenticateUserPinAuthenticatePinPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCentreApi
     */
    CallCentreApi.prototype.userPinAuthenticatePinPost = function (bodyAuthenticateUserPinAuthenticatePinPost, options) {
        var _this = this;
        return (0, exports.CallCentreApiFp)(this.configuration).userPinAuthenticatePinPost(bodyAuthenticateUserPinAuthenticatePinPost, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update the pin of a member.
     * @param {string} authId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCentreApi
     */
    CallCentreApi.prototype.userPinUsersAuthIdPinPut = function (authId, body, options) {
        var _this = this;
        return (0, exports.CallCentreApiFp)(this.configuration).userPinUsersAuthIdPinPut(authId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a user on Auth0.  Create an Auth0 user with the given email address, claims its eligibility if available and run login actions if specified.  If the user has active eligibility and login actions were run, the user should be fully provisioned in the platform. Users are auto-verified upon creation.  If the Auth0 user already exists, it will be used to complete the remaining actions. In that case, if we don\'t find a unique match for the email, a 409 Conflict response will be returned.  The `multipass:create:user` scope is required to access this endpoint.
     * @summary Create User
     * @param {CreateUserRequest} createUserRequest
     * @param {string} [userAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallCentreApi
     */
    CallCentreApi.prototype.userUsersPut = function (createUserRequest, userAgent, options) {
        var _this = this;
        return (0, exports.CallCentreApiFp)(this.configuration).userUsersPut(createUserRequest, userAgent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CallCentreApi;
}(base_1.BaseAPI));
exports.CallCentreApi = CallCentreApi;
/**
 * DevApi - axios parameter creator
 * @export
 */
var DevApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthHealthGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/health";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get the calling user info. Enabled in dev environment only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfUsersMeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/users/me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove user.
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUsersAuthIdDelete: function (authId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([authId_1], args_1, true), void 0, function (authId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'authId' is not null or undefined
                            (0, common_1.assertParamExists)('userUsersAuthIdDelete', 'authId', authId);
                            localVarPath = "/users/{auth_id}"
                                .replace("{".concat("auth_id", "}"), encodeURIComponent(String(authId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DevApiAxiosParamCreator = DevApiAxiosParamCreator;
/**
 * DevApi - functional programming interface
 * @export
 */
var DevApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DevApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthHealthGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.healthHealthGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevApi.healthHealthGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the calling user info. Enabled in dev environment only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfUsersMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.selfUsersMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevApi.selfUsersMeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove user.
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUsersAuthIdDelete: function (authId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userUsersAuthIdDelete(authId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DevApi.userUsersAuthIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DevApiFp = DevApiFp;
/**
 * DevApi - factory interface
 * @export
 */
var DevApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DevApiFp)(configuration);
    return {
        /**
         *
         * @summary Get Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthHealthGet: function (options) {
            return localVarFp.healthHealthGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the calling user info. Enabled in dev environment only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfUsersMeGet: function (options) {
            return localVarFp.selfUsersMeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Remove user.
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUsersAuthIdDelete: function (authId, options) {
            return localVarFp.userUsersAuthIdDelete(authId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DevApiFactory = DevApiFactory;
/**
 * DevApi - object-oriented interface
 * @export
 * @class DevApi
 * @extends {BaseAPI}
 */
var DevApi = /** @class */ (function (_super) {
    __extends(DevApi, _super);
    function DevApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevApi
     */
    DevApi.prototype.healthHealthGet = function (options) {
        var _this = this;
        return (0, exports.DevApiFp)(this.configuration).healthHealthGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the calling user info. Enabled in dev environment only.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevApi
     */
    DevApi.prototype.selfUsersMeGet = function (options) {
        var _this = this;
        return (0, exports.DevApiFp)(this.configuration).selfUsersMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Remove user.
     * @param {string} authId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevApi
     */
    DevApi.prototype.userUsersAuthIdDelete = function (authId, options) {
        var _this = this;
        return (0, exports.DevApiFp)(this.configuration).userUsersAuthIdDelete(authId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DevApi;
}(base_1.BaseAPI));
exports.DevApi = DevApi;
/**
 * MemberSSOApi - axios parameter creator
 * @export
 */
var MemberSSOApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Link the authenticated Auth0 user to another.  Call the endpoint **with an empty request body** to link an authenticated SSO user to a new Dialogue user that will be created using the same email.  Call the endpoint **with an access token in the request body** in addition to the one in the authorization header to link the 2 users. Both users must be from different identities provider: one user is a Dialogue one and the other an SSO one.  We then try to enrol Dialogue user using the information from the SSO user data.
         * @summary Link the authenticated Auth0 user to another.
         * @param {string} [userAgent]
         * @param {BodyLinkSelfUsersMeLinkPost} [bodyLinkSelfUsersMeLinkPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfUsersMeLinkPost: function (userAgent_1, bodyLinkSelfUsersMeLinkPost_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userAgent_1, bodyLinkSelfUsersMeLinkPost_1], args_1, true), void 0, function (userAgent, bodyLinkSelfUsersMeLinkPost, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/users/me/link";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            if (userAgent != null) {
                                localVarHeaderParameter['user-agent'] = String(userAgent);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bodyLinkSelfUsersMeLinkPost, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.MemberSSOApiAxiosParamCreator = MemberSSOApiAxiosParamCreator;
/**
 * MemberSSOApi - functional programming interface
 * @export
 */
var MemberSSOApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MemberSSOApiAxiosParamCreator)(configuration);
    return {
        /**
         * Link the authenticated Auth0 user to another.  Call the endpoint **with an empty request body** to link an authenticated SSO user to a new Dialogue user that will be created using the same email.  Call the endpoint **with an access token in the request body** in addition to the one in the authorization header to link the 2 users. Both users must be from different identities provider: one user is a Dialogue one and the other an SSO one.  We then try to enrol Dialogue user using the information from the SSO user data.
         * @summary Link the authenticated Auth0 user to another.
         * @param {string} [userAgent]
         * @param {BodyLinkSelfUsersMeLinkPost} [bodyLinkSelfUsersMeLinkPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfUsersMeLinkPost: function (userAgent, bodyLinkSelfUsersMeLinkPost, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.selfUsersMeLinkPost(userAgent, bodyLinkSelfUsersMeLinkPost, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MemberSSOApi.selfUsersMeLinkPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.MemberSSOApiFp = MemberSSOApiFp;
/**
 * MemberSSOApi - factory interface
 * @export
 */
var MemberSSOApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MemberSSOApiFp)(configuration);
    return {
        /**
         * Link the authenticated Auth0 user to another.  Call the endpoint **with an empty request body** to link an authenticated SSO user to a new Dialogue user that will be created using the same email.  Call the endpoint **with an access token in the request body** in addition to the one in the authorization header to link the 2 users. Both users must be from different identities provider: one user is a Dialogue one and the other an SSO one.  We then try to enrol Dialogue user using the information from the SSO user data.
         * @summary Link the authenticated Auth0 user to another.
         * @param {string} [userAgent]
         * @param {BodyLinkSelfUsersMeLinkPost} [bodyLinkSelfUsersMeLinkPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfUsersMeLinkPost: function (userAgent, bodyLinkSelfUsersMeLinkPost, options) {
            return localVarFp.selfUsersMeLinkPost(userAgent, bodyLinkSelfUsersMeLinkPost, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MemberSSOApiFactory = MemberSSOApiFactory;
/**
 * MemberSSOApi - object-oriented interface
 * @export
 * @class MemberSSOApi
 * @extends {BaseAPI}
 */
var MemberSSOApi = /** @class */ (function (_super) {
    __extends(MemberSSOApi, _super);
    function MemberSSOApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Link the authenticated Auth0 user to another.  Call the endpoint **with an empty request body** to link an authenticated SSO user to a new Dialogue user that will be created using the same email.  Call the endpoint **with an access token in the request body** in addition to the one in the authorization header to link the 2 users. Both users must be from different identities provider: one user is a Dialogue one and the other an SSO one.  We then try to enrol Dialogue user using the information from the SSO user data.
     * @summary Link the authenticated Auth0 user to another.
     * @param {string} [userAgent]
     * @param {BodyLinkSelfUsersMeLinkPost} [bodyLinkSelfUsersMeLinkPost]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberSSOApi
     */
    MemberSSOApi.prototype.selfUsersMeLinkPost = function (userAgent, bodyLinkSelfUsersMeLinkPost, options) {
        var _this = this;
        return (0, exports.MemberSSOApiFp)(this.configuration).selfUsersMeLinkPost(userAgent, bodyLinkSelfUsersMeLinkPost, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MemberSSOApi;
}(base_1.BaseAPI));
exports.MemberSSOApi = MemberSSOApi;
/**
 * SuperadminApi - axios parameter creator
 * @export
 */
var SuperadminApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Update a user\'s email without requiring them to login. Tenant enforced.
         * @param {string} authId
         * @param {UpdateUserEmailRequest} updateUserEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEmailUsersAuthIdEmailPatch: function (authId_1, updateUserEmailRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([authId_1, updateUserEmailRequest_1], args_1, true), void 0, function (authId, updateUserEmailRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'authId' is not null or undefined
                            (0, common_1.assertParamExists)('userEmailUsersAuthIdEmailPatch', 'authId', authId);
                            // verify required parameter 'updateUserEmailRequest' is not null or undefined
                            (0, common_1.assertParamExists)('userEmailUsersAuthIdEmailPatch', 'updateUserEmailRequest', updateUserEmailRequest);
                            localVarPath = "/users/{auth_id}/email"
                                .replace("{".concat("auth_id", "}"), encodeURIComponent(String(authId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateUserEmailRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Allows Superadmins to initiate password reset for user\'s.
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordUsersAuthIdResetPasswordPost: function (authId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([authId_1], args_1, true), void 0, function (authId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'authId' is not null or undefined
                            (0, common_1.assertParamExists)('userPasswordUsersAuthIdResetPasswordPost', 'authId', authId);
                            localVarPath = "/users/{auth_id}/reset_password"
                                .replace("{".concat("auth_id", "}"), encodeURIComponent(String(authId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SuperadminApiAxiosParamCreator = SuperadminApiAxiosParamCreator;
/**
 * SuperadminApi - functional programming interface
 * @export
 */
var SuperadminApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SuperadminApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Update a user\'s email without requiring them to login. Tenant enforced.
         * @param {string} authId
         * @param {UpdateUserEmailRequest} updateUserEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEmailUsersAuthIdEmailPatch: function (authId, updateUserEmailRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userEmailUsersAuthIdEmailPatch(authId, updateUserEmailRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperadminApi.userEmailUsersAuthIdEmailPatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Allows Superadmins to initiate password reset for user\'s.
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordUsersAuthIdResetPasswordPost: function (authId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userPasswordUsersAuthIdResetPasswordPost(authId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SuperadminApi.userPasswordUsersAuthIdResetPasswordPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SuperadminApiFp = SuperadminApiFp;
/**
 * SuperadminApi - factory interface
 * @export
 */
var SuperadminApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SuperadminApiFp)(configuration);
    return {
        /**
         *
         * @summary Update a user\'s email without requiring them to login. Tenant enforced.
         * @param {string} authId
         * @param {UpdateUserEmailRequest} updateUserEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEmailUsersAuthIdEmailPatch: function (authId, updateUserEmailRequest, options) {
            return localVarFp.userEmailUsersAuthIdEmailPatch(authId, updateUserEmailRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Allows Superadmins to initiate password reset for user\'s.
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordUsersAuthIdResetPasswordPost: function (authId, options) {
            return localVarFp.userPasswordUsersAuthIdResetPasswordPost(authId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SuperadminApiFactory = SuperadminApiFactory;
/**
 * SuperadminApi - object-oriented interface
 * @export
 * @class SuperadminApi
 * @extends {BaseAPI}
 */
var SuperadminApi = /** @class */ (function (_super) {
    __extends(SuperadminApi, _super);
    function SuperadminApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Update a user\'s email without requiring them to login. Tenant enforced.
     * @param {string} authId
     * @param {UpdateUserEmailRequest} updateUserEmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperadminApi
     */
    SuperadminApi.prototype.userEmailUsersAuthIdEmailPatch = function (authId, updateUserEmailRequest, options) {
        var _this = this;
        return (0, exports.SuperadminApiFp)(this.configuration).userEmailUsersAuthIdEmailPatch(authId, updateUserEmailRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Allows Superadmins to initiate password reset for user\'s.
     * @param {string} authId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperadminApi
     */
    SuperadminApi.prototype.userPasswordUsersAuthIdResetPasswordPost = function (authId, options) {
        var _this = this;
        return (0, exports.SuperadminApiFp)(this.configuration).userPasswordUsersAuthIdResetPasswordPost(authId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SuperadminApi;
}(base_1.BaseAPI));
exports.SuperadminApi = SuperadminApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
var UserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get an Auth0 user\'s `external_claims` from the `app_metadata`.
         * @summary Get a user\'s Auth0 external claims.
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExternalClaimsUsersAuthIdExternalClaimsGet: function (authId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([authId_1], args_1, true), void 0, function (authId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'authId' is not null or undefined
                            (0, common_1.assertParamExists)('userExternalClaimsUsersAuthIdExternalClaimsGet', 'authId', authId);
                            localVarPath = "/users/{auth_id}/external_claims"
                                .replace("{".concat("auth_id", "}"), encodeURIComponent(String(authId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication HTTPBearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
var UserApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get an Auth0 user\'s `external_claims` from the `app_metadata`.
         * @summary Get a user\'s Auth0 external claims.
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExternalClaimsUsersAuthIdExternalClaimsGet: function (authId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userExternalClaimsUsersAuthIdExternalClaimsGet(authId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.userExternalClaimsUsersAuthIdExternalClaimsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
var UserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UserApiFp)(configuration);
    return {
        /**
         * Get an Auth0 user\'s `external_claims` from the `app_metadata`.
         * @summary Get a user\'s Auth0 external claims.
         * @param {string} authId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExternalClaimsUsersAuthIdExternalClaimsGet: function (authId, options) {
            return localVarFp.userExternalClaimsUsersAuthIdExternalClaimsGet(authId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get an Auth0 user\'s `external_claims` from the `app_metadata`.
     * @summary Get a user\'s Auth0 external claims.
     * @param {string} authId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.userExternalClaimsUsersAuthIdExternalClaimsGet = function (authId, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).userExternalClaimsUsersAuthIdExternalClaimsGet(authId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserApi;
}(base_1.BaseAPI));
exports.UserApi = UserApi;
